import PropTypes from 'prop-types';

import FilterRadioButton from '../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../components/FilterRadioButtonsContainer';
import FormGroup from '../../../components/FormGroup';
import Input from '../../../components/Input';

export default function UrbsCard({
  numeroCartaoURBS,
  handleNumeroCartaoURBSChange,
  hasCartaoURBS,
  setHasCartaoURBS,
  getErrorMessageByFieldName,
}) {
  return (
    <>
      <div className="title">
        Possui cartão URBS?
      </div>
      <FilterRadioButtonsContainer>
        <FilterRadioButton
          selected={hasCartaoURBS === true}
          onClick={() => setHasCartaoURBS(true)}
        >
          SIM
        </FilterRadioButton>
        <FilterRadioButton
          selected={hasCartaoURBS === false}
          onClick={() => setHasCartaoURBS(false)}
        >
          NÃO
        </FilterRadioButton>
      </FilterRadioButtonsContainer>

      {hasCartaoURBS && (
        <>
          <div className="title">
            Informe o número do seu cartão URBS.
          </div>
          <FormGroup error={getErrorMessageByFieldName('numeroCartaoURBS')}>
            <Input
              placeholder="Número do cartão URBS"
              value={numeroCartaoURBS}
              onChange={handleNumeroCartaoURBSChange}
              maxLength="25"
              error={getErrorMessageByFieldName('numeroCartaoURBS')}
            />
          </FormGroup>
        </>
      )}
    </>
  );
}

UrbsCard.propTypes = {
  numeroCartaoURBS: PropTypes.string.isRequired,
  handleNumeroCartaoURBSChange: PropTypes.func.isRequired,
  hasCartaoURBS: PropTypes.bool,
  setHasCartaoURBS: PropTypes.func.isRequired,
  getErrorMessageByFieldName: PropTypes.func.isRequired,
};

UrbsCard.defaultProps = {
  hasCartaoURBS: null,
};
